module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp2_3009.f73d6124.png";